// ── Mobile menu ──────────────────────────────────────────────────
document.addEventListener('DOMContentLoaded', function(){
  var burger = document.getElementById('navBurger');
  var menu   = document.getElementById('mobileMenu');
  if(burger && menu){
    burger.addEventListener('click', function(){
      menu.classList.toggle('open');
    });
  }

  // ── Product image thumbnails ─────────────────────────────────
  document.querySelectorAll('.thumb').forEach(function(t){
    t.addEventListener('click', function(){
      var main = document.getElementById('mainProductImg');
      if(main){ main.src = t.src; }
      document.querySelectorAll('.thumb').forEach(function(x){ x.classList.remove('active'); });
      t.classList.add('active');
    });
  });

  // ── Quantity control ─────────────────────────────────────────
  window.changeQty = function(delta){
    var inp = document.getElementById('qtyInput');
    if(!inp) return;
    var v = parseInt(inp.value)||1;
    inp.value = Math.max(1, v + delta);
  };

  // ── Collection sort ──────────────────────────────────────────
  var sortSel = document.getElementById('sortSelect');
  if(sortSel){ sortSel.addEventListener('change', function(){ location = this.value; }); }

  // ── Category tab filtering (collection page) ─────────────────
  var tabs = document.querySelectorAll('.cat-tab[data-cat]');
  var sections = document.querySelectorAll('.cat-section');
  tabs.forEach(function(tab){
    tab.addEventListener('click', function(){
      tabs.forEach(function(t){ t.classList.remove('active'); });
      tab.classList.add('active');
      var cat = tab.dataset.cat;
      sections.forEach(function(sec){
        sec.style.display = (cat === 'all' || sec.id === 'section-' + cat) ? '' : 'none';
      });
      if(cat !== 'all'){
        var target = document.getElementById('section-' + cat);
        if(target) target.scrollIntoView({ behavior:'smooth', block:'start' });
      }
    });
  });

  // ── Quote type toggle ────────────────────────────────────────
  window.switchQuoteType = function(type){
    document.querySelectorAll('.toggle-btn').forEach(function(b){
      b.classList.toggle('active', b.dataset.type === type);
    });
    var qf = document.getElementById('quoteFields');
    var sf = document.getElementById('sampleFields');
    var title = document.getElementById('formTitle');
    if(type === 'sample'){
      if(qf) qf.style.display = 'none';
      if(sf) sf.style.display = '';
      if(title) title.textContent = 'Request a Sample';
    } else {
      if(qf) qf.style.display = '';
      if(sf) sf.style.display = 'none';
      if(title) title.textContent = 'Request a Quote';
    }
  };

  // ── WhatsApp form submission (homepage + quote page) ─────────
  window.submitQuoteForm = function(e){
    e.preventDefault();
    var f = e.target;
    var get = function(id){ var el = f.querySelector('#' + id) || document.getElementById(id); return el ? el.value.trim() : ''; };
    var name     = get('qName');
    var company  = get('qCompany');
    var email    = get('qEmail');
    var country  = get('qCountry');
    var category = get('qCategory');
    var qty      = get('qQty');
    var msg      = get('qMsg');
    var type     = get('qType') || 'Quote';

    var text = 'Hello Always Twenty! I would like to request a ' + type + '.\n\n'
      + 'Name: ' + name + '\n'
      + 'Company: ' + company + '\n'
      + 'Email: ' + email + '\n'
      + 'Country: ' + country + '\n'
      + 'Category: ' + category + '\n'
      + 'Quantity: ' + (qty || 'Not specified') + '\n'
      + (msg ? 'Message: ' + msg : '');

    var wa = document.body.dataset.waNumber || '8613900000000';
    window.open('https://wa.me/' + wa + '?text=' + encodeURIComponent(text), '_blank');

    // show success
    var wrap = f.closest('#quoteFormWrap') || f.parentElement;
    if(wrap){
      var success = wrap.querySelector('.quote-success') || document.getElementById('quoteSuccess');
      if(success){ f.style.display = 'none'; success.style.display = ''; }
    }
  };

  // ── AJAX add-to-cart ─────────────────────────────────────────
  window.addToCart = function(variantId, qty){
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function(r){ return r.json(); })
      .then(function(){ window.location.href = '/cart'; })
      .catch(function(err){ console.error(err); });
  };
});

  // ── Product page: Request Quote button ───────────────────────
  window.requestProductQuote = function(productTitle, sku){
    var qty = document.getElementById('qtyInput') ? document.getElementById('qtyInput').value : '100';
    var msg = 'Hello Always Twenty,\n\nI am interested in requesting a wholesale quote for:\n\nProduct: ' + productTitle + (sku ? '\nSKU: ' + sku : '') + '\nQuantity: ' + qty + ' pcs\n\nPlease send me your best wholesale price and lead time. Thank you!';
    var waUrl = 'https://wa.me/8613800138000?text=' + encodeURIComponent(msg);
    window.open(waUrl, '_blank');
  };
